import { gql } from '@apollo/client';

export const GET_THOUGHTSPOT_TOKEN = gql`
  query thoughtspotToken($userName: String!) {
    thoughtspotToken(userName: $userName)
  }
`;
